import { useEffect } from 'react';

// Custom hook for lightbox styles
export const useLightboxStyles = () => {
  useEffect(() => {
    // Add custom styles for the lightbox to ensure it appears on top
    const style = document.createElement('style');
    style.innerHTML = `
      /* Ensure lightbox appears on top of everything */
      .yarl__container {
        z-index: 9999 !important; /* Higher z-index to ensure it's on top */
      }
      
      /* Make sure the lightbox is truly fullscreen */
      .yarl__portal {
        position: fixed !important;
        inset: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        background-color: rgba(0, 0, 0, 0.9) !important;
      }
      
      /* Ensure content is centered */
      .yarl__flex_center {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);
}; 